import React from 'react';

const BookingSuccess = () => {
  return (
    <div className="container text-center mt-5">
      <h2 className="text-success">🎉 Appointment Booked Successfully!</h2>
      <p className="lead mt-3">
        Thank you for trusting PharmaCart. A pharmacist will reach out to you shortly.
      </p>
      <a href="/" className="btn btn-primary mt-4">Back to Home</a>
    </div>
  );
};

export default BookingSuccess;
